import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

function SupportGuidePopup({ isPopup, setIsPopup, GuideData }){
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);  // 팝업만 닫기
  };

  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };
  

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className="pop_title line">제작지원 가이드</h4>
              <div className='close_btn_con'>
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
              <div className="pop_addr_con scroll_custom pd_b16">
                <div className="b1_2 g-90" style={{padding:'0 12px'}}>
                  <div dangerouslySetInnerHTML={{ __html: GuideData }}></div>
                </div>
              </div>

            </div>
          </div>
        </div>
    );
};

export default SupportGuidePopup;